<div class="d-flex justify-content-between align-items-center mb-3">
  <div class="row">
    <div class="col d-flex">
      <h1 class="fs-5 fw-bold mb-0">Funnels</h1>
    </div>
  </div>

  <div class="d-flex gap-2">
    <a [routerLink]="'add'" *isGranted="['ROLE_API_WIDGET_WRITE']" class="btn btn-primary fw-bold"><i
      class="bi bi-plus-lg me-2"></i>Add Funnel</a>
  </div>
</div>

<div class="card border-0 shadow mb-3 fade-in-zoom">
  <div class="card-body">
    <div class="d-flex gap-3 align-items-center mb-3">
      <input type="text" [(ngModel)]="filters.values['name']" (ngModelChange)="onNameChange()" class="form-control"
             placeholder="Filter by name" style="padding: 11px;">

      <app-dropdown-select [(ngModel)]="filters.values['productId']" (onDropdownChange)="filters.onFilterChange()" [multiple]="true"
                           placeholder="Filter by brand" class="form-control">
        @for (product of products; track product.id) {
          <app-dropdown-select-option [value]="product.id">{{ product }}</app-dropdown-select-option>
        }
      </app-dropdown-select>

      <app-dropdown-select [(ngModel)]="filters.values['domains']" (onDropdownChange)="filters.onFilterChange()" [multiple]="true"
                           placeholder="Filter by domain" class="form-control">
        @for (domain of domains; track domain.id) {
          <app-dropdown-select-option [value]="domain.id">{{ domain }}</app-dropdown-select-option>
        }
      </app-dropdown-select>

      <input type="text" [(ngModel)]="filters.values['slug']" (ngModelChange)="onSlugChange()" class="form-control"
             placeholder="Filter by slug" style="padding: 11px;">

      <button type="button" class="btn btn-outline-primary ms-2" (click)="filters.saveFilters()" title="Save filters">
        <i class="bi bi-floppy"></i>
      </button>
      <button type="button" class="btn btn-outline-secondary ms-2" (click)="filters.clearFilters()" title="Clear filters">
        <i class="bi bi-eraser"></i>
      </button>
    </div>

    <div class="table-responsive">
      <table class="table table-hover table-striped align-middle">
        <thead class="bg-tertiary">
        <tr [tableSorter]="tableSorter" (tableSorterChange)="fetchAll()">
          <th tableSorterHeader="id">ID</th>
          <th tableSorterHeader="name">Name</th>
          <th tableSorterHeader="domain">Domain</th>
          <th tableSorterHeader="slug">Slug</th>
          <th>URL</th>
          <th tableSorterHeader="enabled">Status</th>
          <th class="text-end">Action</th>
        </tr>
        </thead>
        <tbody>
          @for (funnel of funnels; track funnel.id) {
            <tr>
              <td>{{ funnel.id }}</td>
              <td>{{ funnel.name }}</td>
              <td>{{ funnel.domain?.domain ?? '' }}</td>
              <td>{{ funnel.slug }}</td>
              <td>
                <div class="input-group">
                  <input type="text" [value]="getFunnelUrl(funnel)" class="form-control" readonly>
                  <a class="btn btn-primary" [href]="getFunnelUrl(funnel)" target="_blank">
                    <i class="bi bi-link"></i>
                  </a>
                </div>
              </td>
              <td>
                @if (funnel.enabled) {
                  <span class="badge bg-success"><i class="bi bi-check-circle me-2"></i>Active</span>
                } @else {
                  <span class="badge bg-danger"><i class="bi bi-x-circle me-2"></i>Disabled</span>
                }
              </td>
              <td class="text-end">
                <a class="btn btn-outline-primary btn-sm" [routerLink]="[funnel.id]">
                  <i class="bi bi-pencil me-1"></i>Edit
                </a>
                <button class="btn btn-outline-secondary btn-sm ms-1" appConfirm (click)="duplicate(funnel)">
                  <i class="bi bi-copy me-1"></i>Duplicate
                </button>
                <button class="btn btn-outline-danger btn-sm ms-1" appConfirm (click)="delete(funnel)">
                  <i class="bi bi-trash"></i>
                </button>
              </td>
            </tr>
          }
        </tbody>
      </table>

      <app-paginator (pageChange)="fetchAll()" [paginator]="paginator"></app-paginator>
    </div>
  </div>
</div>
